import { DetailDiagramEdge } from './Edge'

export default function edgeRouter({ edge, onEdgeClick, theme = null }) {
  return <DetailDiagramEdge onEdgeClick={onEdgeClick} theme={theme} />
}
